import { fromJS } from 'immutable';


const payPalLocaleMap = fromJS({
    'ar-ae': 'ar_AE',
    'ar-bh': 'ar_BH',
    'ar-dz': 'ar_DZ',
    'ar-eg': 'ar_EG',
    'ar-jo': 'ar_JO',
    'ar-kw': 'ar_KW',
    'ar-ma': 'ar_MA',
    'ar-om': 'ar_OM',
    'ar-qa': 'ar_QA',
    'ar-sa': 'ar_SA',
    'ar-tn': 'ar_TN',
    'ar-ye': 'ar_YE',
    'da-dk': 'da_DK',
    'da-fo': 'da_FO',
    'da-gl': 'da_GL',
    'de-at': 'de_AT',
    'de-ch': 'de_CH',
    'de-de': 'de_DE',
    'de-lu': 'de_LU',
    'en-ad': 'en_AD',
    'en-ae': 'en_AE',
    'en-ag': 'en_AG',
    'en-ai': 'en_AI',
    'en-al': 'en_AL',
    'en-am': 'en_AM',
    'en-ao': 'en_AO',
    'en-ar': 'en_AR',
    'en-at': 'en_AT',
    'en-au': 'en_AU',
    'en-aw': 'en_AW',
    'en-az': 'en_AZ',
    'en-ba': 'en_BA',
    'en-bb': 'en_BB',
    'en-be': 'en_BE',
    'en-bf': 'en_BF',
    'en-bg': 'en_BG',
    'en-bh': 'en_BH',
    'en-bi': 'en_BI',
    'en-bj': 'en_BJ',
    'en-bm': 'en_BM',
    'en-bn': 'en_BN',
    'en-bo': 'en_BO',
    'en-br': 'en_BR',
    'en-bs': 'en_BS',
    'en-bt': 'en_BT',
    'en-bw': 'en_BW',
    'en-by': 'en_BY',
    'en-bz': 'en_BZ',
    'en-c2': 'en_C2',
    'en-ca': 'en_CA',
    'en-cd': 'en_CD',
    'en-cg': 'en_CG',
    'en-ch': 'en_CH',
    'en-ci': 'en_CI',
    'en-ck': 'en_CK',
    'en-cl': 'en_CL',
    'en-cm': 'en_CM',
    'en-co': 'en_CO',
    'en-cr': 'en_CR',
    'en-cv': 'en_CV',
    'en-cy': 'en_CY',
    'en-cz': 'en_CZ',
    'en-de': 'en_DE',
    'en-dj': 'en_DJ',
    'en-dk': 'en_DK',
    'en-dm': 'en_DM',
    'en-do': 'en_DO',
    'en-dz': 'en_DZ',
    'en-ec': 'en_EC',
    'en-ee': 'en_EE',
    'en-eg': 'en_EG',
    'en-er': 'en_ER',
    'en-es': 'en_ES',
    'en-et': 'en_ET',
    'en-fi': 'en_FI',
    'en-fj': 'en_FJ',
    'en-fk': 'en_FK',
    'en-fm': 'en_FM',
    'en-fo': 'en_FO',
    'en-fr': 'en_FR',
    'en-ga': 'en_GA',
    'en-gb': 'en_GB',
    'en-gd': 'en_GD',
    'en-ge': 'en_GE',
    'en-gf': 'en_GF',
    'en-gi': 'en_GI',
    'en-gl': 'en_GL',
    'en-gm': 'en_GM',
    'en-gn': 'en_GN',
    'en-gp': 'en_GP',
    'en-gr': 'en_GR',
    'en-gt': 'en_GT',
    'en-gw': 'en_GW',
    'en-gy': 'en_GY',
    'en-hk': 'en_HK',
    'en-hn': 'en_HN',
    'en-hr': 'en_HR',
    'en-hu': 'en_HU',
    'en-id': 'en_ID',
    'en-ie': 'en_IE',
    'en-il': 'en_IL',
    'en-in': 'en_IN',
    'en-is': 'en_IS',
    'en-it': 'en_IT',
    'en-jm': 'en_JM',
    'en-jo': 'en_JO',
    'en-jp': 'en_JP',
    'en-ke': 'en_KE',
    'en-kg': 'en_KG',
    'en-kh': 'en_KH',
    'en-ki': 'en_KI',
    'en-km': 'en_KM',
    'en-kn': 'en_KN',
    'en-kr': 'en_KR',
    'en-kw': 'en_KW',
    'en-ky': 'en_KY',
    'en-kz': 'en_KZ',
    'en-la': 'en_LA',
    'en-lc': 'en_LC',
    'en-li': 'en_LI',
    'en-lk': 'en_LK',
    'en-ls': 'en_LS',
    'en-lt': 'en_LT',
    'en-lu': 'en_LU',
    'en-lv': 'en_LV',
    'en-ma': 'en_MA',
    'en-mc': 'en_MC',
    'en-md': 'en_MD',
    'en-me': 'en_ME',
    'en-mg': 'en_MG',
    'en-mh': 'en_MH',
    'en-mk': 'en_MK',
    'en-ml': 'en_ML',
    'en-mn': 'en_MN',
    'en-mq': 'en_MQ',
    'en-mr': 'en_MR',
    'en-ms': 'en_MS',
    'en-mt': 'en_MT',
    'en-mu': 'en_MU',
    'en-mv': 'en_MV',
    'en-mw': 'en_MW',
    'en-mx': 'en_MX',
    'en-my': 'en_MY',
    'en-mz': 'en_MZ',
    'en-na': 'en_NA',
    'en-nc': 'en_NC',
    'en-ne': 'en_NE',
    'en-nf': 'en_NF',
    'en-ng': 'en_NG',
    'en-ni': 'en_NI',
    'en-nl': 'en_NL',
    'en-no': 'en_NO',
    'en-np': 'en_NP',
    'en-nr': 'en_NR',
    'en-nu': 'en_NU',
    'en-nz': 'en_NZ',
    'en-om': 'en_OM',
    'en-pa': 'en_PA',
    'en-pe': 'en_PE',
    'en-pf': 'en_PF',
    'en-pg': 'en_PG',
    'en-ph': 'en_PH',
    'en-pl': 'en_PL',
    'en-pm': 'en_PM',
    'en-pn': 'en_PN',
    'en-pt': 'en_PT',
    'en-pw': 'en_PW',
    'en-py': 'en_PY',
    'en-qa': 'en_QA',
    'en-re': 'en_RE',
    'en-ro': 'en_RO',
    'en-rs': 'en_RS',
    'en-ru': 'en_RU',
    'en-rw': 'en_RW',
    'en-sa': 'en_SA',
    'en-sb': 'en_SB',
    'en-sc': 'en_SC',
    'en-se': 'en_SE',
    'en-sg': 'en_SG',
    'en-sh': 'en_SH',
    'en-si': 'en_SI',
    'en-sj': 'en_SJ',
    'en-sk': 'en_SK',
    'en-sl': 'en_SL',
    'en-sm': 'en_SM',
    'en-sn': 'en_SN',
    'en-so': 'en_SO',
    'en-sr': 'en_SR',
    'en-st': 'en_ST',
    'en-sv': 'en_SV',
    'en-sz': 'en_SZ',
    'en-tc': 'en_TC',
    'en-td': 'en_TD',
    'en-tg': 'en_TG',
    'en-th': 'en_TH',
    'en-tj': 'en_TJ',
    'en-tm': 'en_TM',
    'en-tn': 'en_TN',
    'en-to': 'en_TO',
    'en-tt': 'en_TT',
    'en-tv': 'en_TV',
    'en-tw': 'en_TW',
    'en-tz': 'en_TZ',
    'en-ua': 'en_UA',
    'en-ug': 'en_UG',
    'en-us': 'en_US',
    'en-uy': 'en_UY',
    'en-va': 'en_VA',
    'en-vc': 'en_VC',
    'en-ve': 'en_VE',
    'en-vg': 'en_VG',
    'en-vn': 'en_VN',
    'en-vu': 'en_VU',
    'en-wf': 'en_WF',
    'en-ws': 'en_WS',
    'en-ye': 'en_YE',
    'en-yt': 'en_YT',
    'en-za': 'en_ZA',
    'en-zm': 'en_ZM',
    'en-zw': 'en_ZW',
    'es-ad': 'es_AD',
    'es-ae': 'es_AE',
    'es-ag': 'es_AG',
    'es-ai': 'es_AI',
    'es-am': 'es_AM',
    'es-ao': 'es_AO',
    'es-ar': 'es_AR',
    'es-aw': 'es_AW',
    'es-az': 'es_AZ',
    'es-bb': 'es_BB',
    'es-bf': 'es_BF',
    'es-bh': 'es_BH',
    'es-bi': 'es_BI',
    'es-bj': 'es_BJ',
    'es-bm': 'es_BM',
    'es-bo': 'es_BO',
    'es-bs': 'es_BS',
    'es-bw': 'es_BW',
    'es-bz': 'es_BZ',
    'es-cd': 'es_CD',
    'es-cg': 'es_CG',
    'es-ck': 'es_CK',
    'es-cl': 'es_CL',
    'es-co': 'es_CO',
    'es-cr': 'es_CR',
    'es-cv': 'es_CV',
    'es-cz': 'es_CZ',
    'es-dj': 'es_DJ',
    'es-dm': 'es_DM',
    'es-do': 'es_DO',
    'es-dz': 'es_DZ',
    'es-ec': 'es_EC',
    'es-ee': 'es_EE',
    'es-eg': 'es_EG',
    'es-er': 'es_ER',
    'es-es': 'es_ES',
    'es-et': 'es_ET',
    'es-fi': 'es_FI',
    'es-fj': 'es_FJ',
    'es-fk': 'es_FK',
    'es-fo': 'es_FO',
    'es-ga': 'es_GA',
    'es-gd': 'es_GD',
    'es-ge': 'es_GE',
    'es-gf': 'es_GF',
    'es-gi': 'es_GI',
    'es-gl': 'es_GL',
    'es-gm': 'es_GM',
    'es-gn': 'es_GN',
    'es-gp': 'es_GP',
    'es-gr': 'es_GR',
    'es-gt': 'es_GT',
    'es-gw': 'es_GW',
    'es-gy': 'es_GY',
    'es-hn': 'es_HN',
    'es-hu': 'es_HU',
    'es-ie': 'es_IE',
    'es-jm': 'es_JM',
    'es-jo': 'es_JO',
    'es-ke': 'es_KE',
    'es-kg': 'es_KG',
    'es-ki': 'es_KI',
    'es-km': 'es_KM',
    'es-kn': 'es_KN',
    'es-kw': 'es_KW',
    'es-ky': 'es_KY',
    'es-kz': 'es_KZ',
    'es-lc': 'es_LC',
    'es-li': 'es_LI',
    'es-ls': 'es_LS',
    'es-lt': 'es_LT',
    'es-lu': 'es_LU',
    'es-lv': 'es_LV',
    'es-ma': 'es_MA',
    'es-mg': 'es_MG',
    'es-mh': 'es_MH',
    'es-ml': 'es_ML',
    'es-mq': 'es_MQ',
    'es-mr': 'es_MR',
    'es-ms': 'es_MS',
    'es-mu': 'es_MU',
    'es-mw': 'es_MW',
    'es-mx': 'es_MX',
    'es-mz': 'es_MZ',
    'es-na': 'es_NA',
    'es-nc': 'es_NC',
    'es-ne': 'es_NE',
    'es-nf': 'es_NF',
    'es-ni': 'es_NI',
    'es-nr': 'es_NR',
    'es-nu': 'es_NU',
    'es-nz': 'es_NZ',
    'es-om': 'es_OM',
    'es-pa': 'es_PA',
    'es-pe': 'es_PE',
    'es-pf': 'es_PF',
    'es-pg': 'es_PG',
    'es-pm': 'es_PM',
    'es-pn': 'es_PN',
    'es-pw': 'es_PW',
    'es-py': 'es_PY',
    'es-qa': 'es_QA',
    'es-re': 'es_RE',
    'es-ro': 'es_RO',
    'es-rs': 'es_RS',
    'es-rw': 'es_RW',
    'es-sa': 'es_SA',
    'es-sb': 'es_SB',
    'es-sc': 'es_SC',
    'es-sh': 'es_SH',
    'es-si': 'es_SI',
    'es-sj': 'es_SJ',
    'es-sk': 'es_SK',
    'es-sl': 'es_SL',
    'es-sm': 'es_SM',
    'es-sn': 'es_SN',
    'es-so': 'es_SO',
    'es-sr': 'es_SR',
    'es-st': 'es_ST',
    'es-sv': 'es_SV',
    'es-sz': 'es_SZ',
    'es-tc': 'es_TC',
    'es-td': 'es_TD',
    'es-tg': 'es_TG',
    'es-tj': 'es_TJ',
    'es-tm': 'es_TM',
    'es-tn': 'es_TN',
    'es-tt': 'es_TT',
    'es-tv': 'es_TV',
    'es-tz': 'es_TZ',
    'es-ua': 'es_UA',
    'es-ug': 'es_UG',
    'es-us': 'es_US',
    'es-uy': 'es_UY',
    'es-va': 'es_VA',
    'es-vc': 'es_VC',
    'es-ve': 'es_VE',
    'es-vg': 'es_VG',
    'es-vu': 'es_VU',
    'es-wf': 'es_WF',
    'es-ye': 'es_YE',
    'es-yt': 'es_YT',
    'es-za': 'es_ZA',
    'es-zm': 'es_ZM',
    'fr-ad': 'fr_AD',
    'fr-ae': 'fr_AE',
    'fr-ag': 'fr_AG',
    'fr-ai': 'fr_AI',
    'fr-am': 'fr_AM',
    'fr-ao': 'fr_AO',
    'fr-aw': 'fr_AW',
    'fr-az': 'fr_AZ',
    'fr-bb': 'fr_BB',
    'fr-be': 'fr_BE',
    'fr-bf': 'fr_BF',
    'fr-bh': 'fr_BH',
    'fr-bi': 'fr_BI',
    'fr-bj': 'fr_BJ',
    'fr-bm': 'fr_BM',
    'fr-bo': 'fr_BO',
    'fr-bs': 'fr_BS',
    'fr-bw': 'fr_BW',
    'fr-bz': 'fr_BZ',
    'fr-ca': 'fr_CA',
    'fr-cd': 'fr_CD',
    'fr-cg': 'fr_CG',
    'fr-ch': 'fr_CH',
    'fr-ci': 'fr_CI',
    'fr-ck': 'fr_CK',
    'fr-cl': 'fr_CL',
    'fr-cm': 'fr_CM',
    'fr-co': 'fr_CO',
    'fr-cr': 'fr_CR',
    'fr-cv': 'fr_CV',
    'fr-cz': 'fr_CZ',
    'fr-dj': 'fr_DJ',
    'fr-dm': 'fr_DM',
    'fr-do': 'fr_DO',
    'fr-dz': 'fr_DZ',
    'fr-ec': 'fr_EC',
    'fr-ee': 'fr_EE',
    'fr-eg': 'fr_EG',
    'fr-er': 'fr_ER',
    'fr-et': 'fr_ET',
    'fr-fi': 'fr_FI',
    'fr-fj': 'fr_FJ',
    'fr-fk': 'fr_FK',
    'fr-fo': 'fr_FO',
    'fr-fr': 'fr_FR',
    'fr-ga': 'fr_GA',
    'fr-gb': 'fr_GB',
    'fr-gd': 'fr_GD',
    'fr-ge': 'fr_GE',
    'fr-gf': 'fr_GF',
    'fr-gi': 'fr_GI',
    'fr-gl': 'fr_GL',
    'fr-gm': 'fr_GM',
    'fr-gn': 'fr_GN',
    'fr-gp': 'fr_GP',
    'fr-gr': 'fr_GR',
    'fr-gt': 'fr_GT',
    'fr-gw': 'fr_GW',
    'fr-gy': 'fr_GY',
    'fr-hn': 'fr_HN',
    'fr-hu': 'fr_HU',
    'fr-ie': 'fr_IE',
    'fr-jm': 'fr_JM',
    'fr-jo': 'fr_JO',
    'fr-ke': 'fr_KE',
    'fr-kg': 'fr_KG',
    'fr-ki': 'fr_KI',
    'fr-km': 'fr_KM',
    'fr-kn': 'fr_KN',
    'fr-kw': 'fr_KW',
    'fr-ky': 'fr_KY',
    'fr-kz': 'fr_KZ',
    'fr-lc': 'fr_LC',
    'fr-li': 'fr_LI',
    'fr-ls': 'fr_LS',
    'fr-lt': 'fr_LT',
    'fr-lu': 'fr_LU',
    'fr-lv': 'fr_LV',
    'fr-ma': 'fr_MA',
    'fr-mc': 'fr_MC',
    'fr-mg': 'fr_MG',
    'fr-mh': 'fr_MH',
    'fr-ml': 'fr_ML',
    'fr-mq': 'fr_MQ',
    'fr-mr': 'fr_MR',
    'fr-ms': 'fr_MS',
    'fr-mu': 'fr_MU',
    'fr-mw': 'fr_MW',
    'fr-mz': 'fr_MZ',
    'fr-na': 'fr_NA',
    'fr-nc': 'fr_NC',
    'fr-ne': 'fr_NE',
    'fr-nf': 'fr_NF',
    'fr-ni': 'fr_NI',
    'fr-nr': 'fr_NR',
    'fr-nu': 'fr_NU',
    'fr-nz': 'fr_NZ',
    'fr-om': 'fr_OM',
    'fr-pa': 'fr_PA',
    'fr-pe': 'fr_PE',
    'fr-pf': 'fr_PF',
    'fr-pg': 'fr_PG',
    'fr-pm': 'fr_PM',
    'fr-pn': 'fr_PN',
    'fr-pw': 'fr_PW',
    'fr-qa': 'fr_QA',
    'fr-re': 'fr_RE',
    'fr-ro': 'fr_RO',
    'fr-rs': 'fr_RS',
    'fr-rw': 'fr_RW',
    'fr-sa': 'fr_SA',
    'fr-sb': 'fr_SB',
    'fr-sc': 'fr_SC',
    'fr-sh': 'fr_SH',
    'fr-si': 'fr_SI',
    'fr-sj': 'fr_SJ',
    'fr-sk': 'fr_SK',
    'fr-sl': 'fr_SL',
    'fr-sm': 'fr_SM',
    'fr-sn': 'fr_SN',
    'fr-so': 'fr_SO',
    'fr-sr': 'fr_SR',
    'fr-st': 'fr_ST',
    'fr-sv': 'fr_SV',
    'fr-sz': 'fr_SZ',
    'fr-tc': 'fr_TC',
    'fr-td': 'fr_TD',
    'fr-tg': 'fr_TG',
    'fr-tj': 'fr_TJ',
    'fr-tm': 'fr_TM',
    'fr-tn': 'fr_TN',
    'fr-tt': 'fr_TT',
    'fr-tv': 'fr_TV',
    'fr-tz': 'fr_TZ',
    'fr-ua': 'fr_UA',
    'fr-ug': 'fr_UG',
    'fr-us': 'fr_US',
    'fr-uy': 'fr_UY',
    'fr-va': 'fr_VA',
    'fr-vc': 'fr_VC',
    'fr-ve': 'fr_VE',
    'fr-vg': 'fr_VG',
    'fr-vu': 'fr_VU',
    'fr-wf': 'fr_WF',
    'fr-ye': 'fr_YE',
    'fr-yt': 'fr_YT',
    'fr-za': 'fr_ZA',
    'fr-zm': 'fr_ZM',
    'he-il': 'he_IL',
    'id-id': 'id_ID',
    'it-it': 'it_IT',
    'ja-jp': 'ja_JP',
    'ko-kr': 'ko_KR',
    'nl-be': 'nl_BE',
    'nl-nl': 'nl_NL',
    'no-no': 'no_NO',
    'pl-pl': 'pl_PL',
    'pt-br': 'pt_BR',
    'pt-pt': 'pt_PT',
    'ru-ee': 'ru_EE',
    'ru-lt': 'ru_LT',
    'ru-lv': 'ru_LV',
    'ru-ru': 'ru_RU',
    'ru-ua': 'ru_UA',
    'sv-se': 'sv_SE',
    'th-th': 'th_TH',
    'zh-ad': 'zh_AD',
    'zh-ae': 'zh_AE',
    'zh-ag': 'zh_AG',
    'zh-ai': 'zh_AI',
    'zh-am': 'zh_AM',
    'zh-ao': 'zh_AO',
    'zh-aw': 'zh_AW',
    'zh-az': 'zh_AZ',
    'zh-bb': 'zh_BB',
    'zh-bf': 'zh_BF',
    'zh-bh': 'zh_BH',
    'zh-bi': 'zh_BI',
    'zh-bj': 'zh_BJ',
    'zh-bm': 'zh_BM',
    'zh-bo': 'zh_BO',
    'zh-bs': 'zh_BS',
    'zh-bw': 'zh_BW',
    'zh-bz': 'zh_BZ',
    'zh-c2': 'zh_C2',
    'zh-cd': 'zh_CD',
    'zh-cg': 'zh_CG',
    'zh-ck': 'zh_CK',
    'zh-cl': 'zh_CL',
    'zh-cn': 'zh_CN',
    'zh-co': 'zh_CO',
    'zh-cr': 'zh_CR',
    'zh-cv': 'zh_CV',
    'zh-cz': 'zh_CZ',
    'zh-dj': 'zh_DJ',
    'zh-dm': 'zh_DM',
    'zh-do': 'zh_DO',
    'zh-dz': 'zh_DZ',
    'zh-ec': 'zh_EC',
    'zh-ee': 'zh_EE',
    'zh-eg': 'zh_EG',
    'zh-er': 'zh_ER',
    'zh-et': 'zh_ET',
    'zh-fi': 'zh_FI',
    'zh-fj': 'zh_FJ',
    'zh-fk': 'zh_FK',
    'zh-fo': 'zh_FO',
    'zh-ga': 'zh_GA',
    'zh-gd': 'zh_GD',
    'zh-ge': 'zh_GE',
    'zh-gf': 'zh_GF',
    'zh-gi': 'zh_GI',
    'zh-gl': 'zh_GL',
    'zh-gm': 'zh_GM',
    'zh-gn': 'zh_GN',
    'zh-gp': 'zh_GP',
    'zh-gr': 'zh_GR',
    'zh-gt': 'zh_GT',
    'zh-gw': 'zh_GW',
    'zh-gy': 'zh_GY',
    'zh-hk': 'zh_HK',
    'zh-hn': 'zh_HN',
    'zh-hu': 'zh_HU',
    'zh-ie': 'zh_IE',
    'zh-jm': 'zh_JM',
    'zh-jo': 'zh_JO',
    'zh-ke': 'zh_KE',
    'zh-kg': 'zh_KG',
    'zh-ki': 'zh_KI',
    'zh-km': 'zh_KM',
    'zh-kn': 'zh_KN',
    'zh-kw': 'zh_KW',
    'zh-ky': 'zh_KY',
    'zh-kz': 'zh_KZ',
    'zh-lc': 'zh_LC',
    'zh-li': 'zh_LI',
    'zh-ls': 'zh_LS',
    'zh-lt': 'zh_LT',
    'zh-lu': 'zh_LU',
    'zh-lv': 'zh_LV',
    'zh-ma': 'zh_MA',
    'zh-mg': 'zh_MG',
    'zh-mh': 'zh_MH',
    'zh-ml': 'zh_ML',
    'zh-mq': 'zh_MQ',
    'zh-mr': 'zh_MR',
    'zh-ms': 'zh_MS',
    'zh-mu': 'zh_MU',
    'zh-mw': 'zh_MW',
    'zh-mz': 'zh_MZ',
    'zh-na': 'zh_NA',
    'zh-nc': 'zh_NC',
    'zh-ne': 'zh_NE',
    'zh-nf': 'zh_NF',
    'zh-ni': 'zh_NI',
    'zh-nr': 'zh_NR',
    'zh-nu': 'zh_NU',
    'zh-nz': 'zh_NZ',
    'zh-om': 'zh_OM',
    'zh-pa': 'zh_PA',
    'zh-pe': 'zh_PE',
    'zh-pf': 'zh_PF',
    'zh-pg': 'zh_PG',
    'zh-pm': 'zh_PM',
    'zh-pn': 'zh_PN',
    'zh-pw': 'zh_PW',
    'zh-qa': 'zh_QA',
    'zh-re': 'zh_RE',
    'zh-ro': 'zh_RO',
    'zh-rs': 'zh_RS',
    'zh-rw': 'zh_RW',
    'zh-sa': 'zh_SA',
    'zh-sb': 'zh_SB',
    'zh-sc': 'zh_SC',
    'zh-sh': 'zh_SH',
    'zh-si': 'zh_SI',
    'zh-sj': 'zh_SJ',
    'zh-sk': 'zh_SK',
    'zh-sl': 'zh_SL',
    'zh-sm': 'zh_SM',
    'zh-sn': 'zh_SN',
    'zh-so': 'zh_SO',
    'zh-sr': 'zh_SR',
    'zh-st': 'zh_ST',
    'zh-sv': 'zh_SV',
    'zh-sz': 'zh_SZ',
    'zh-tc': 'zh_TC',
    'zh-td': 'zh_TD',
    'zh-tg': 'zh_TG',
    'zh-tj': 'zh_TJ',
    'zh-tm': 'zh_TM',
    'zh-tn': 'zh_TN',
    'zh-tt': 'zh_TT',
    'zh-tv': 'zh_TV',
    'zh-tw': 'zh_TW',
    'zh-tz': 'zh_TZ',
    'zh-ua': 'zh_UA',
    'zh-ug': 'zh_UG',
    'zh-us': 'zh_US',
    'zh-uy': 'zh_UY',
    'zh-va': 'zh_VA',
    'zh-vc': 'zh_VC',
    'zh-ve': 'zh_VE',
    'zh-vg': 'zh_VG',
    'zh-vu': 'zh_VU',
    'zh-wf': 'zh_WF',
    'zh-ye': 'zh_YE',
    'zh-yt': 'zh_YT',
    'zh-za': 'zh_ZA',
    'zh-zm': 'zh_ZM'
});

export default payPalLocaleMap;
